import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { onUnmounted, reactive, watch } from 'vue';
import { type ContextMenuItem, type ContextMenu, CONTEXT_MENU_ACTION, CONTEXT_MENU_EVENT, CONTEXT_MENU_ID } from '@/angular-app/libs/fabric/fabric.contextmenu';
import type { CanvasEx } from '@/typings/canvas';
import type { Object as FabricObject } from 'fabric/fabric-impl';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasContextMenu',
  props: {
    canvas: null,
    events: null
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    events?: Record<CONTEXT_MENU_ACTION, (element?: FabricObject) => void>
};

_useCssVars((_vm, _setup) => ({
  "b0883a6a": (_setup.menu.y),
  "b0883a6c": (_setup.menu.x)
}))



const menu = reactive({
    x: '0px',
    y: '0px',
    items: [] as ContextMenuItem[],
    element: undefined as FabricObject | undefined
});

const handleItemClick = async (item: ContextMenuItem) => {
    let handler: (() => void | Promise<void>) | undefined;
    if (item.onClick) {
        handler = item.onClick;
    } else if (item.action && props.events?.[item.action]) {
        handler = () => props.events![item.action!](menu.element);
    }

    if (handler) {
        await handler();
    }

    onMenuClosed();
    window.DD_RUM?.addAction(`${item.label} - Right Click Menu`);
};

const onMenuOpened = (event: ContextMenu) => {
    menu.x = `${event.x}px`;
    menu.y = `${event.y}px`;
    menu.items = [...event.items];
    menu.element = event.selectedElement;
};

const onMenuClosed = () => {
    menu.items = [];
};

watch(
    () => props.canvas,
    (canvas) => {
        if (!canvas) return;
        props.canvas.on(CONTEXT_MENU_EVENT.SHOW, onMenuOpened);
        props.canvas.on(CONTEXT_MENU_EVENT.HIDE, onMenuClosed);
    },
    { immediate: true }
);

onUnmounted(() => {
    props.canvas.off(CONTEXT_MENU_EVENT.SHOW, onMenuOpened);
    props.canvas.off(CONTEXT_MENU_EVENT.HIDE, onMenuClosed);
});

return { __sfc: true,props, menu, handleItemClick, onMenuOpened, onMenuClosed, CONTEXT_MENU_ID }
}

})